import React,{useEffect} from 'react'
import { NavLink } from 'react-router-dom';
import { Weather } from './Weather';
import { useLocation } from 'react-router-dom'
import { useAuthContext } from '../../context/Auth/Create';

export const SidebarLeft=()=> {
	const location=useLocation();
	const routeName=location.pathname;
	const userAuth=useAuthContext();
	useEffect(()=>{
		const script=document.createElement("script");
		script.src="assets/js/app.min.js";
		script.async=true;
		document.body.appendChild(script);
		return () => {
		  document.body.removeChild(script);
		}
		  },[])
	useEffect(()=>{
	    document.querySelectorAll(".has-sub").forEach((menu)=>{
		if(menu.classList.contains("active")){
			menu.children[1].style.display="block"        
 		}	
		else{
			menu.children[1].style.display="none"  
		}
		
		menu.firstChild.onclick=(e)=>{
		e.preventDefault();
		if(menu.classList.contains("active")){
			menu.classList.remove("active");
			menu.children[1].style.display="none"        
 		}	
		else{
			menu.classList.add("active");
			menu.children[1].style.display="block"   
		}
	
	    }
		});        
		  },[])
	
return (
    <>
    		<div id="sidebar" className="app-sidebar">
			{/* <!-- BEGIN scrollbar --> */}
			<div className="app-sidebar-content" data-scrollbar="true" data-height="100%" >
				{/* <!-- BEGIN menu --> */}
				<div className="menu"style={{marginTop:"32px"}}>
					
					{/* <div className="menu-item">
                      <Weather/>
					</div> */}
					
					<div className={`${routeName ==="/dashboard"?"menu-item active":"menu-item"}`}>
						<NavLink to="/dashboard" className="menu-link">
							<span className="menu-icon"><i className="bi bi-cpu"></i></span>
							<span className="menu-text">Dashboard</span>
						</NavLink> 
					</div>
					{!!userAuth?.user?.isHightAuthority && <><div className={`${routeName ==="/building-occupancy"?"menu-item active":"menu-item"}`}>
						<NavLink to="/building-occupancy" className="menu-link">
							<span className="menu-icon"><i className="bi bi-cpu"></i></span>
							<span className="menu-text">Building Occupancy</span>
						</NavLink> 
					</div></>}
					
					{/* {(userAuth.user && userAuth.user.permissions.includes("MallAnalytics")) && <><div className={`${routeName ==="/analytics"?"menu-item active":"menu-item"}`}>
					<NavLink to="/analytics" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Analytics</span>
						</NavLink> 
					</div></>}
		{(userAuth.user && userAuth.user.permissions.includes("Reports")) &&  <><div className={`${routeName ==="/monthly-report"?"menu-item active":"menu-item"}`}>
					<NavLink to="/monthly-report" className="menu-link">
							<span className="menu-icon"><i className="bi bi-bar-chart"></i></span>
							<span className="menu-text">Monthly Report</span>
						</NavLink> 
					</div></>}
        {(userAuth.user && userAuth.user.permissions.includes("FloorWise")) &&  <>	<div className={`${routeName ==="/floor-wise"?"menu-item active":"menu-item"}`}>
					<NavLink to="/floor-wise" className="menu-link">
							<span className="menu-icon"><i className="far fa-hospital"></i></span>
							<span className="menu-text">Floor Wise</span>
						</NavLink> 
					</div></>} */}
      
       
       
      
	  {/* {(userAuth.user && userAuth.user.permissions.includes("MallAnalytics")) && <><div className={`${routeName ==="/analytics"?"menu-item active":"menu-item"}`}>
					<NavLink to="/analytics" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Analytics</span>
						</NavLink> 
					</div></>}
         */}
       
					
				
				
					{/* <div className={`${routeName ==="/escalation"?"menu-item active":"menu-item"}`}>
					<NavLink to="/escalation" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Escalation</span>
						</NavLink> 
					</div> */}
					
				
				
					{/* {(userAuth.user && userAuth.user.permissions.includes("Anpr")) && <><div className={`${routeName ==="/anpr-report"?"menu-item active":"menu-item"}`}>
					<NavLink to="/anpr-report" className="menu-link" >
							<span className="menu-icon"><i className="fas fa-car"></i>

</span>
							<span className="menu-text">ANPR</span>
						</NavLink> 
					</div></>} */}
					{(userAuth.user && userAuth.user.permissions.includes("Fr")) && <><div className={`${routeName ==="/fr"?"menu-item active":"menu-item"}`}>
					<NavLink to="/fr" className="menu-link">
							<span className="menu-icon"><i className="fas fa-smile"></i></span>
							<span className="menu-text">Facial Recognition</span>
						</NavLink>
					</div></>}
					{(userAuth.user && userAuth.user.permissions.includes("Fr In/OUT")) && <><div className={`${routeName ==="/in-out"?"menu-item active":"menu-item"}`}>
					<NavLink to="/in-out" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Employee FR In/Out Report</span>
						</NavLink> 
					</div></>}
					{(userAuth.user && userAuth.user.permissions.includes("Missing People")) && <><div className={`${routeName ==="/missing-people"?"menu-item active":"menu-item"}`}>
					<NavLink to="/missing-people" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Missing People</span>
						</NavLink> 
					</div></>}
					{/* {(userAuth.user && userAuth.user.permissions.includes("Missing People")) && <><div className={`${routeName ==="/check-outs"?"menu-item active":"menu-item"}`}>
					<NavLink to="/check-outs" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Check Outs Miss</span>
						</NavLink> 
					</div></>} */}
					{(userAuth.user && userAuth.user.permissions.includes("Day Wise Report")) && <><div className={`${routeName ==="/daily-wise-report"?"menu-item active":"menu-item"}`}>
					<NavLink to="/daily-wise-report" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Day Wise Report</span>
						</NavLink>
					</div></>}
					{(userAuth.user && userAuth.user.permissions.includes("Month Wise Report")) && <><div className={`${routeName ==="/monthly-wise-report"?"menu-item active":"menu-item"}`}>
					<NavLink to="/monthly-wise-report" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Month Wise Report</span>
						</NavLink>
					</div></>}
					{(userAuth.user && userAuth.user.permissions.includes("Month Wise Report")) && <><div className={`${routeName ==="/user-wise-report"?"menu-item active":"menu-item"}`}>
					<NavLink to="/user-wise-report" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">User Wise Report</span>
						</NavLink>
					</div></>}
					{(userAuth.user && userAuth.user.permissions.includes("Live Stream")) && <div className={`${routeName ==="/live-attendance"?"menu-item active":"menu-item"}`}>
					<NavLink to="/live-attendance" className="menu-link">
							<span className="menu-icon"><i className="fa-solid fa-person "></i></span>
							<span className="menu-text">Live Attendance</span>
						</NavLink> 
					</div>}
					{/* {(userAuth.user && userAuth.user.permissions.includes("Live Stream")) && userAuth.user.name ==="Admin" && <><div className={`${routeName ==="/live-stream"?"menu-item active":"menu-item"}`}>
					<NavLink to="/live-stream" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Live Stream</span>
						</NavLink>
					</div></>} */}
					{/* {(userAuth.user && userAuth.user.permissions.includes("ANPR")) &&   <><div className={`${routeName ==="/anpr-report"?"menu-item active":"menu-item"}`}>
					<NavLink to="/anpr-report" className="menu-link">
							<span className="menu-icon"><i className="fas fa-car"></i></span>
							<span className="menu-text">ANPR Reports</span>
						</NavLink> 
					</div></>} */}
					{/* {(userAuth.user && userAuth.user.permissions.includes("Live Stream") || userAuth.user && userAuth.user.permissions.includes("Restricted Area")) && <div className={`${["/anpr-report","/live-attendance"].includes(routeName)?"menu-item has-sub active expand":"menu-item has-sub"}`} >
						<a className="menu-link" >
							<div className="menu-icon">
								<i className="bi bi-bag-check"></i>
								<span className="w-5px h-5px rounded-3 bg-theme position-absolute top-0 end-0 mt-3px me-3px"></span>
							</div>
							<div className="menu-text d-flex align-items-center">Live Stream Page</div> 
							<span className="menu-caret"><b className="caret"></b></span>
						</a>
					<div className={`${routeName ==="/live-attendance"?"menu-item active":"menu-item"}`} style={{paddingLeft:"25px"}}>
					{(userAuth.user && userAuth.user.permissions.includes("Live Stream")) &&   <><NavLink to="/live-attendance" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Live Attendance</span>
						</NavLink > </>}
					{(userAuth.user && userAuth.user.permissions.includes("Restricted Area")) &&   <><NavLink to="/restricted-area" className="menu-link">
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Restricted Area</span>
						</NavLink > </>}
						
						
					</div>
					</div>} */}
					{(userAuth.user && userAuth.user.permissions.includes("Role")) &&  <><div className={`${routeName ==="/role"?"menu-item active":"menu-item"}`}>
					<NavLink to="/role" className="menu-link" >
							<span className="menu-icon"><i className="fa fa-lock"></i></span>
							<span className="menu-text">Role</span>
						</NavLink>
					</div></>}
					{(userAuth.user && userAuth.user.permissions.includes("User")) &&  <><div className={`${routeName ==="/user"?"menu-item active":"menu-item"}`}>
					<NavLink to="/user" className="menu-link" >
							<span className="menu-icon"><i className="far fa-user"></i></span>
							<span className="menu-text">User</span>
						</NavLink>
					</div></>}
					{/* {(userAuth.user && userAuth.user.permissions.includes("HeatMaps")) && <div className={`${routeName ==="/heat-map"?"menu-item active":"menu-item"}`}>
					<NavLink to="/heat-map" className="menu-link">
							<span className="menu-icon"><i className="fa-solid fa-map"></i></span>
							<span className="menu-text">Heat Maps</span>
						</NavLink> 
					</div>} */}
					
					
					
					
					
		{/* {(userAuth.user && userAuth.user.permissions.includes("Reports")) &&  <><div className={`${routeName ==="/monthly-report"?"menu-item active":"menu-item"}`}>
					<a  className="menu-link" style={{color:"rgb(72, 72, 72)"}}>
							<span className="menu-icon"><i className="bi bi-bar-chart"></i></span>
							<span className="menu-text">Monthly Report</span>
						</a> 
					</div></>}
        {(userAuth.user && userAuth.user.permissions.includes("FloorWise")) &&  <>	<div className={`${routeName ==="/floor-wise"?"menu-item active":"menu-item"}`}>
					<a className="menu-link" style={{color:"rgb(72, 72, 72)"}}>
							<span className="menu-icon"><i className="far fa-hospital"></i></span>
							<span className="menu-text">Floor Wise</span>
						</a> 
					</div></>}
						<div className={`${routeName ==="/escalation"?"menu-item active":"menu-item"}`}>
					<a className="menu-link" style={{color:"rgb(72, 72, 72)"}}>
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Escalation</span>
						</a> 
					</div>

					<div className={`${routeName ==="/fashion"?"menu-item active":"menu-item"}`}>
					<a className="menu-link" style={{color:"rgb(72, 72, 72)"}}>
							<span className="menu-icon"><i className="bi bi-grid-3x3"></i></span>
							<span className="menu-text">Fashion</span>
						</a> 
					</div>
					
					
					
        {(userAuth.user && userAuth.user.permissions.includes("User")) &&  <><div className={`${routeName ==="/user"?"menu-item active":"menu-item"}`}>
					<a className="menu-link" style={{color:"rgb(72, 72, 72)"}}>
							<span className="menu-icon"><i className="far fa-user"></i></span>
							<span className="menu-text">User</span>
						</a> 
					</div></>}
					
					
					<div className={`${["/food-wise-report","/special-area"].includes(routeName)?"menu-item has-sub active expand":"menu-item has-sub"}`} >
						<a className="menu-link" style={{color:"rgb(72, 72, 72)"}}>
							<div className="menu-icon">
								<i className="bi bi-bag-check"></i>
								<span className="w-5px h-5px rounded-3 bg-theme position-absolute top-0 end-0 mt-3px me-3px"></span>
							</div>
							<div className="menu-text d-flex align-items-center">Special Area</div> 
							<span className="menu-caret"><b className="caret"></b></span>
						</a>
					<div className={`${routeName ==="/food-wise-report"?"menu-item active":"menu-item"}`}>
					{(userAuth.user && userAuth.user.permissions.includes("FoodCourt")) &&   <><a className="menu-link" style={{color:"rgb(72, 72, 72)"}}>
							<span className="menu-icon"><i className="fa fa-cutlery"></i></span>
							<span className="menu-text">Food Court</span>
						</a> </>}
						{(userAuth.user && userAuth.user.permissions.includes("AnchorTeanuts")) &&  <><div className={`${routeName ==="/special-area"?"menu-item active":"menu-item"}`}>
						<a className="menu-link" style={{color:"rgb(72, 72, 72)"}}>
							<span className="menu-icon"><i className="fa-solid fa-store"></i>

</span>
							<span className="menu-text">Targeted Area</span>
						</a> 
						</div></>}
						
					</div>
					</div>
					
				
					<div className="menu-divider"></div>
					 */}
				</div>
				
			
			</div>
			
		</div>
		
		<button className="app-sidebar-mobile-backdrop" data-toggle-target=".app" data-toggle-class="app-sidebar-mobile-toggled"></button>
    </>
  )
}
